import { EventItemEntity } from "../../entities/service-book/event-item";

export class EventItemCreateRequest {
   EventItemEntity: EventItemEntity;
}